module.exports = __webpack_public_path__ + "img/5f_r_iso@2x.5f1f3968.png";